import { Component, OnInit } from '@angular/core';
import { MiraieService } from '../Services/miraie.service';
import { AnalysisService } from '../Services/analysis.service';
import { OutputService } from '../Services/output.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';
import { e } from '@angular/core/src/render3';

@Component({
  selector: 'app-lost-analysis',
  templateUrl: './lost-analysis.component.html',
  styleUrls: ['./lost-analysis.component.css']
})
export class LostAnalysisComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  years: number[] = [2018, 2017, 2016, 2015, 2014];
  /*
    months: any[] = [
      { month: 7, disabled: false },
      { month: 8, disabled: false },
      { month: 9, disabled: false },
      { month: 10, disabled: false },
      { month: 11, disabled: false },
      { month: 12, disabled: false },
      { month: 1, disabled: false },
      { month: 2, disabled: false },
      { month: 3, disabled: false },
      { month: 4, disabled: false },
      { month: 5, disabled: false },
      { month: 6, disabled: false },
    ];
    */
  months: any[] = [
    { month: 7, view: false, score: null, disabled: false },
    { month: 8, view: false, score: null, disabled: false },
    { month: 9, view: false, score: null, disabled: false },
    { month: 10, view: false, score: null, disabled: false },
    { month: 11, view: false, score: null, disabled: false },
    { month: 12, view: false, score: null, disabled: false },
    { month: 1, view: false, score: null, disabled: false },
    { month: 2, view: false, score: null, disabled: false },
    { month: 3, view: false, score: null, disabled: false },
    { month: 4, view: false, score: null, disabled: false },
    { month: 5, view: false, score: null, disabled: false },
    { month: 6, view: false, score: null, disabled: false },
  ];
  year: number;
  month: number;
  all_year = false;

  objectKeys = Object.keys;
  result;
  lost_list = {};
  ap_lost_list = {};
  app_lost_list = {};

  result_list;
  srcurl: string;
  data_list;
  user_list;
  summay_data_list;

  constructor(
    private miraieService: MiraieService,
    private analysisService: AnalysisService,
    private outputService: OutputService,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.mkYears();
    this.srcurl = this.miraieService.srcurl;
    this.year = new Date().getFullYear();
    //this.month = new Date().getMonth() + 1;
    var month = new Date().getMonth() + 1;
    if (month < 7) {
      this.year--;
    }
    this.months.map(function (value) {
      if (value.month == month) {
        return value.view = true;
      }
    });
    this.analysisService.getCodeAnalysis([14, 15, 16]).subscribe(code => {
      this.lostList(code);
      this.changeRecord();
    });
  }
  mkYears() {
    let min = 2018;
    let max = new Date().getFullYear();
    let m = new Date().getMonth() + 1;
    if (m < 7) {
      max--;
    }
    this.years = [];
    let year_list = [];
    for (let i = min; i <= max; i++) {
      year_list.push(i);
    }
    year_list.sort(function (a, b) {
      if (a > b) return -1;
      if (a < b) return 1;
      return 0;
    }
    );
    this.years = year_list;
  }

  //指定した年度のデータ取得
  changeRecord() {
    this.ListHide();
    this.analysisService.getLostAnalysis(this.year).subscribe(result => {
      this.data_list = result;
      this.monthSummary();
    });
  }

  SearchRecord() {
    if (this.data_list) {
      this.monthSummary();
    }
  }

  monthSummary() {
    //let sum_list = this.data_list[this.month];
    //this.summay_data_list = sum_list;

    var month_sum = {};
    this.months.forEach(month => {
      if (month.view && (month.month in this.data_list)) {
        let sum_list = this.data_list[month.month];
        Object.keys(sum_list).forEach(user => {
          if (user in month_sum) {
            Object.keys(sum_list[user]['total_detail']).forEach(key => {
              if (key in month_sum[user]['total_detail']) {
                month_sum[user]['total_detail'][key] += sum_list[user]['total_detail'][key];
              } else {
                month_sum[user]['total_detail'][key] = sum_list[user]['total_detail'][key];
              }
            });
            Object.keys(sum_list[user]['ap_detail']).forEach(key => {
              if (key in month_sum[user]['ap_detail']) {
                month_sum[user]['ap_detail'][key] += sum_list[user]['ap_detail'][key];
              } else {
                month_sum[user]['ap_detail'][key] = sum_list[user]['ap_detail'][key];
              }
            });
            Object.keys(sum_list[user]['app_detail']).forEach(key => {
              if (key in month_sum[user]['app_detail']) {
                month_sum[user]['app_detail'][key] += sum_list[user]['app_detail'][key];
              } else {
                month_sum[user]['app_detail'][key] = sum_list[user]['app_detail'][key];
              }
            });
          } else {
            month_sum[user] = Object.assign({}, sum_list[user]);
          }
        });
      }
    });
    this.summay_data_list = month_sum;

  }

  //敗因コードリスト
  lostList(codelist) {
    const lost_cause = 14;
    const ap_lost = 14;
    const app_lost = 14;
    codelist.forEach(code => {
      if (code.code_kbn == lost_cause) {
        this.lost_list[code.no] = {
          code: code.code,
          no: code.no,
          name: code.item_name,
          cnt: 0,
        }
      }
      if (code.code_kbn == ap_lost) {
        this.ap_lost_list[code.no] = {
          code: code.code,
          no: code.no,
          name: code.item_name,
          cnt: 0,
        }
      }
      if (code.code_kbn == app_lost) {
        this.app_lost_list[code.no] = {
          code: code.code,
          no: code.no,
          name: code.item_name,
          cnt: 0,
        }
      }
    });
  }

  //未来のチェックボックスをクリック不可に
  ListHide() {
    this.months.forEach(item => {
      var y = this.year;
      if (item.month < 7) y++;
      let sel = new Date(y, item.month);
      let now = new Date(new Date().getFullYear(), new Date().getMonth() + 1);
      if (now < sel) {
        item.disabled = true;
      } else {
        item.disabled = false;
      }
    });
  }

  customTrackBy(index: number, obj: any): any {
    return index;
  }
  //年間チェック
  allYearCheck() {
    if (this.all_year) {
      this.months.forEach(month => {
        month.view = month.disabled ? false : true;
      });
    } else if (!this.all_year) {
      this.months.forEach(month => {
        if (month.month == new Date().getMonth() + 1) {
          month.view = true;
        } else {
          month.view = false;
        }
      });
    }
    this.SearchRecord();
  }

  //Excel出力
  output() {
    //var date = this.year + "-" + this.month;
    var select_month = [];
    this.months.forEach(month => {
      if (month.view) select_month.push(month.month);
    });
    var date = this.year + '-' + select_month.join(',');
    //let res = this.outputService.lost(date, this.result_list)
    let res = this.outputService.lost(date, this.summay_data_list)
    res.subscribe(res => {
      // console.log( res );
      const url = this.srcurl + "output/lost/失注原因_" + (date.replace(/,/g , '_')) + ".xlsx";
      window.open(url);
    });
  }

}
